
define('jst!slot_machine_count/_counter',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="slot-machine-counter">\n  <div class="count"><%= count %></count>\n</div>');
 });

